import { authRoles } from 'app/auth';
import PredictionDeviceEditForm from './editform/PredictionDeviceEditForm';
import PredictionDeviceTable from './table/PredictionDeviceTable';

export default [
	{
		path: '/prediction-device/edit/:id',
		component: PredictionDeviceEditForm,
		auth: authRoles.predictionDevice
	},
	{
		path: '/prediction-device/:sessionNameParam?',
		component: PredictionDeviceTable,
		auth: authRoles.predictionDevice
	}
];
